import dayjs from "dayjs";
import z from "zod";

/**
 * AssistenciaTecnicaSchema
 */

export const AssistenciaTecnicaSchema = z.object({
  codigo: z.string().nullable().default(null),
  tipo: z.coerce.number().nullable().default(null),
  centroCusto: z.coerce.number().nullable().default(null),
  cliente: z.string().nullable().default(null),
  idClienteCentroCusto: z.coerce.number().nullable().default(null),
  unidade: z.string().nullable().default(null),
  dataAbertura: z.coerce.date().nullable().default(null),
  contato: z.string().nullable().default(null),
  previsaoRealizacaoVistoria: z.coerce.date().nullable().default(null),
  prioridade: z.coerce.number().nullable().default(null),
  previsaoTerminoAssistencia: z.coerce.date().nullable().default(null),
  reclamacao: z.string().nullable().default(null),
  procedente: z.coerce.number().nullable().default(null),
  dataReparo: z.coerce.date().nullable().default(null),
  taxa: z.coerce.number().nullable().default(null),
  taxaCliente: z.coerce.number().nullable().default(null),
  valorTaxa: z.coerce.number().nullable().default(null),
  resolvido: z.coerce.number().nullable().default(null),
  dataEncerramento: z.coerce.date().nullable().default(null),
  observacoes: z.string().nullable().default(null),
  custo: z.coerce.number().nullable().default(null),
  nroChamado: z.string().nullable().default(null),
  acoesCorretivas: z.string().nullable().default(null),
  clienteCadastrado: z.boolean().default(false),
  statusAssistencia: z.coerce.number().nullable().default(null),
  categorias: z.array(z.object({
    idCategoriaAssistencia: z.coerce.number(),
    nomeCategoria: z.string(),
    ativo: z.coerce.boolean(),
  })).nullable().default(null),
}).superRefine((data, ctx) => {
  if (data.resolvido === 1) {
    if (data.dataEncerramento === null || dayjs(data.dataEncerramento).isValid() === false) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_date,
        message: "Este campo deve ser preenchido.",
        path: ["dataEncerramento"],
      });
    }
  }
});

/**
 * AssistenciaTecnicaForm
 */

export type AssistenciaTecnicaForm = z.infer<typeof AssistenciaTecnicaSchema>;